export const dashboardsColors = [
    '#74B3CE', // Medium teal
    '#F3A953', // Vibrant goldenrod
    '#A287D4', // Medium purple
    '#5DADEC', // Bright sky blue
    '#88D498', // Soft green
    '#F08A8B', // Coral
    '#F6D55C', // Vibrant yellow
    '#FF7F50', // Coral orange
    '#C597C5', // Rich lavender
    '#7CA982', // Greenish olive
    '#F09BA0', // Warm pink
    '#8FB8DE', // Muted blue
    '#E4A872', // Peachy orange
    '#B889BC', // Pastel mauve
    '#87C9C5', // Aquamarine
    '#F4A261', // Rich orange
    '#79CCE2' // Light cyan
]

export const renderPercentage = (entry: any) => {
    const percentage = (entry.percent * 100).toFixed(0) // Calculate percentage
    return `${percentage}%` // Return percentage as text
}
